import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { generateFixedSizeUrl } from '../../../utils/webp';
import { isMobile } from '../../../utils/adaptive';
import {
  NewsGroupWrapper, NewsGroupInner, ArticleWrapper, CardWrapper,
} from '../styles/newsGroup.style';
import { CarouselArticle } from '../../carousel';
import { VideoArticle } from '../../article-list';
import { TitleImage } from '../../title-image';

import {
  MobileArticle,
  MobileAnchor,
} from '../../article-list/styles/article-list.style';

const propTypes = {
  articles: PropTypes.array,
  backgroundImage: PropTypes.object,
  title: PropTypes.string,
};

const defaultProps = {
  articles: [],
  backgroundImage: { file: { url: '' } },
  title: 'Lorem Ipsum',
};

/**
 * News Group Component
 */
class NewsGroup extends React.Component {
  /**
   * NewsGroup Component Constructor
   * @param {object} props Incoming Props
   */
  constructor(props) {
    super(props);
    this.state = {
      isMobileLocal: false,
    };
  }

  /**
   * Determine if mobile components should be used
   */
  componentDidMount() {
    if (isMobile()) {
      this.setState({ isMobileLocal: true });
    }
  }

  /**
   * Renders the new group
   * @returns {XML} A News Group Component
   */
  render() {
    const { isMobileLocal } = this.state;
    const {
      articles, backgroundImage, title, titleImage,
    } = this.props;
    let outArticles = <div />;

    if (isMobileLocal) {
      outArticles = articles.map((data, index) => {
        let displayDate = moment(data.date).format('MMMM YYYY');
        if (!data.date) {
          displayDate = moment(data.updatedAt).format('Mo YYYY');
        }
        let src = '';
        if (data && data.image && data.image.file && data.image.file.details) {
          src = generateFixedSizeUrl({
            img: {
              path: data.image.file.url,
              width: data.image.file.details.image.width,
              height: data.image.file.details.image.height,
            },
            dimensions: {
              height: 100,
              width: 100,
            },
            ratio: window.devicePixelRatio,
          });
        }
        if (data.videoStill) {
          return <VideoArticle key={index} data={data} isMobile />;
        }
        if (data.externalUrl) {
          return (
            <MobileAnchor key={index} target="blank" href={data.externalUrl}>
              <div className="date">{displayDate}</div>
              <div className="title">{data.title}</div>
              <div className="image" style={{ backgroundImage: `url('${src}')` }} />
            </MobileAnchor>
          );
        }
        return (
          <MobileArticle key={index} to={`/articles/${data.articleSlug}`}>
            <div className="date">{displayDate}</div>
            <div className="title">{data.title}</div>
            <div className="image" style={{ backgroundImage: `url('${src}')` }} />
          </MobileArticle>
        );
      });
    } else {
      outArticles = (
        <ArticleWrapper>
          {articles.map((node, index) => (
            <CardWrapper key={index}>
              {(node && node.videoStill)
                ? <VideoArticle data={node} />
                : <CarouselArticle data={node} />
              }
            </CardWrapper>
          ))}
        </ArticleWrapper>
      );
    }

    return (
      <NewsGroupWrapper backgroundImage={backgroundImage && backgroundImage.file ? backgroundImage.file.url : ''}>
        <NewsGroupInner>
          {titleImage && titleImage.file ? (
            <h1>
              <TitleImage
                className="title-image"
                src={titleImage && titleImage.file && titleImage.file.url}
                alt="title"
              />
            </h1>
          ) : (
            <h3 className="title">{title}</h3>
          )}
          {outArticles}
        </NewsGroupInner>
      </NewsGroupWrapper>
    );
  }
}

NewsGroup.propTypes = propTypes;
NewsGroup.defaultProps = defaultProps;

export default NewsGroup;



// WEBPACK FOOTER //
// ./src/components/news-group/components/newsGroup.js